<script lang="ts">
</script>

<div class="card p-8 pb-4 space-y-4 rounded-none">
	<div class="grid grid-cols-2 xsm:grid-cols-3 sm:grid-cols-4 gap-4 justify-items-center">
		<div class="col-span-2 xsm:col-span-1">
			<img src="/logo.png" class="h-36" alt="Arbatel logo" />
		</div>

		<div class="space-y-2">
			<p class="font-bold">Compañía</p>
			<ul class="grid grid-cols-1 gap-2">
				<a class="!font-normal" href="/nosotros#Quienes-somos">¿Quienes somos?</a>
				<a class="!font-normal" href="/nosotros#Mision">Misión y Visión</a>
				<a class="!font-normal" href="/terminos-y-condiciones#terminos-y-condiciones">Términos y condiciones</a>
				<a class="!font-normal" href="/politica-de-privacidad#politica-de-privacidad">Política de privacidad</a>
			</ul>
		</div>

		<div class="space-y-2">
			<p class="font-bold">Servicio al Cliente</p>
			<ul class="grid grid-cols-1 gap-2">
				<a class="!font-normal" href="/contacto">Contacto</a>
				<a class="!font-normal" href="/nosotros#Formas-de-pago">Formas de pago</a>
				<a class="!font-normal" href="/nosotros#Venta-al-por-mayor">Venta al por mayor</a>
				<a class="!font-normal" href="/politica-de-devoluciones#Politica-de-devoluciones">Política de devoluciones</a>
			</ul>
		</div>

		<div class="col-span-2 xsm:col-span-3 mt-4 sm:mt-0 sm:col-span-1">
			Síguenos en nuestra cuenta de <a
				href="https://www.facebook.com/ArbatelBoutique"
				target="_blank"
				class="!font-normal underline"
				rel="noreferrer">Facebook</a
			>
		</div>
	</div>

	<hr />

	<p class="text-center pb-1">Ⓡ 2023 Comercializadora mexicana Arbatel</p>
</div>
